import React from "react"
import "./styles.css";

const Loader = ({ label = "Loading\u2026" }) => {
    return (
        <div className="loader_panel" role="status" aria-live="polite">
            <div className="loader" />
            <p className="loader_text">{label}</p>
        </div>
    )

}

export default Loader